import { getLocale } from "@/paraglide/runtime";
import type { ResultItem } from "../lib/calculators";
import { roundMoney } from "../lib/finance";

function format(item: ResultItem, locale: string): string {
  if (item.kind === "currency") {
    return roundMoney(item.value).toLocaleString(locale);
  }
  if (item.kind === "percent") {
    return `${(Math.round(item.value * 100) / 100).toLocaleString(locale)}%`;
  }
  return item.value.toLocaleString(locale);
}

/** Result cards (first card emphasized). Amounts are currency-agnostic numbers. */
export function FinanceResult({ items }: { items: ResultItem[] }) {
  const locale = getLocale();
  return (
    <dl className="grid gap-3 sm:grid-cols-3" aria-live="polite">
      {items.map((item, i) => (
        <div
          key={item.label()}
          className={
            i === 0
              ? "rounded-xl bg-primary/10 p-4"
              : "rounded-xl bg-card/40 p-4"
          }
        >
          <dt className="text-xs uppercase tracking-wide text-muted-foreground">
            {item.label()}
          </dt>
          <dd
            className={
              i === 0
                ? "mt-1 font-display text-2xl font-bold tabular-nums text-primary"
                : "mt-1 font-display text-xl font-semibold tabular-nums"
            }
          >
            {format(item, locale)}
          </dd>
        </div>
      ))}
    </dl>
  );
}
